import React from "react";
import LangService from "../../../../services/LangService";
import { useHistory } from "react-router-dom";
import { PAGES } from "../../../../routes/PAGES";
import Block from "../Block";
import TextContent from "../block/TextContent";
import styles from "./Blocks.module.scss";

const FirstBlock = ({ block, community }) => {
    const langMap = LangService.map.pages.welcome;
    const history = useHistory();

    const nextPage = () => {
        gtag("event", "welcome", {
            block: block.type,
        });
        history.push(PAGES.REGISTRATION);
    };
    return (
        <Block className={styles.firstBlock}>
            <div className={styles.leftPanel}>
                <TextContent
                    sectionName={block.sectionName}
                    sectionNameCoBranding={block.sectionNameCoBranding}
                    title={block.title || community.landingTitle || langMap.title}
                    subtitle={
                        block.subtitle || community.landingCopy || langMap.description
                    }
                    buttonText={block.buttonText || langMap.button}
                    nextPage={nextPage}
                    brand={community.brandConfig}
                />
            </div>
            <div className={styles.rightPanel}>
                <img
                    src={block.imgUrl || community.imgUrl}
                    alt={community.communityName || community.title}
                    className={styles.pic}
                />
            </div>
        </Block>
    );
};

export default FirstBlock;
